import {useTranslation} from "react-i18next";

import styles from "./styles.module.scss";

export const SuccessfulPassPopup = () => {
  const {t} = useTranslation();

  return (
    <div className={styles.successfulSave}>
      <h2
        dangerouslySetInnerHTML={{
          __html: t("popup.pass_data.subtitle"),
        }}
      />
    </div>
  );
};
